var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autoSuggest-dialog"},[_c('div',{staticClass:"autoSuggest-container"},_vm._l((_vm.autoSuggest.addresses),function(suggestion){return _c('div',{key:suggestion.uuid,staticClass:"autoSuggest-tile",on:{"click":function($event){return _vm.$emit('click', suggestion)}}},[_vm._v("\n      "+_vm._s(suggestion.label)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }